import { render, staticRenderFns } from "./contract-group-connect-modal.component.vue?vue&type=template&id=2d86e1d8&scoped=true&"
import script from "./contract-group-connect-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-group-connect-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-group-connect-modal.component.vue?vue&type=style&index=0&id=2d86e1d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86e1d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VForm,VTextField})
